export const jsonClone = item => JSON.parse(JSON.stringify(item));
/**
 * Creates a deep clone of the provided object while handling specific data types
 * and circular references.
 *
 * The function uses `JSON.stringify` and `JSON.parse` to clone the object, with a custom
 * replacer function to safely serialize values:
 * - `undefined` and `null` values are replaced with `null`.
 * - `bigint` values are converted to strings.
 * - Non-finite numbers (e.g., `Infinity`, `-Infinity`, `NaN`) are replaced with `null`.
 * - Circular references are replaced with the string `"[Circular]"` to make it explicit.
 *
 * @param {any} obj The object to be cloned. Can be of any type.
 * @returns {any} A deep clone of the input object, with adjustments made during serialization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeJsonClone = (obj) => {
    const seen = new WeakSet();
    return JSON.parse(JSON.stringify(obj, (_k, v) => {
        if (v === undefined || v === null) {
            return null;
        }
        switch (typeof v) {
            case 'bigint':
                return v.toString();
            case 'number':
                return Number.isFinite(v) ? v : null;
            case 'object':
                if (seen.has(v)) {
                    return '[Circular]';
                }
                seen.add(v);
                return v;
            default:
                return v;
        }
    }));
};
export function tryParseToJsonString(data) {
    try {
        return { json: JSON.stringify(data) };
    }
    catch {
        return { json: String(data) };
    }
}
export function compactObject(obj) {
    return Object.fromEntries(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.entries(obj).filter(([key, value]) => value != null));
}
//# sourceMappingURL=json.utils.js.map